module.exports = __webpack_public_path__ + "img/doctor.8ce4ace4.png";